import { Injectable } from '@angular/core';
import { AlertController, LoadingController, ToastController, MenuController } from '@ionic/angular/standalone';


@Injectable({
    providedIn: 'root'
})
export class UIService {


    constructor(
        private toastController: ToastController,
        private alertController: AlertController,
        private loadingController: LoadingController,
        private menuController: MenuController
    ) {
    }

    async showToast(message: string, duration: number = 2000) {
        const toast = await this.toastController.create({
            message,
            duration
        });
        toast.present();
    }

    async presentYesNoAlert(header: string, message: string, noText: string = "No", yesText: string = "Yes") {
        return new Promise<boolean>(async (resolve) => {
            const alert = await this.alertController.create({
                header,
                message,
                buttons: [
                    {
                        text: noText,
                        role: 'cancel',
                        handler: () => resolve(false)
                    }, {
                        text: yesText,
                        handler: () => resolve(true)
                    }
                ]
            });
            await alert.present()
        })
    }

    presentOKAlert(header: string, message: string, text: string = "OK") {
        return new Promise<void>(async (resolve) => {
            const alert = await this.alertController.create({
                header,
                message,
                buttons: [{
                    text,
                    role: 'cancel',
                    handler: () => resolve()
                }]
            });
            await alert.present()
        })
    }

    presentLoading(message: string = "Please wait...") {
        return new Promise<HTMLIonLoadingElement>(async (resolve) => {
            const loading = await this.loadingController.create({
                message,
            });
            await loading.present();
            resolve(loading)
        })
    }

    async importBRFCheck(fileInput: HTMLInputElement, fromMenu = false) {
        if(fromMenu) await this.menuController.close("transactionMenu")
        const response = await this.presentYesNoAlert('Import BRF?', 'You can import a BRF exported from NAB Connect (you can upload either the default .zip they provide or the raw .brf file)')
        if (response) {
            fileInput.click()
        } else if(fromMenu) {
            await this.menuController.open("transactionMenu")
        }
    }

}
